var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * MessageReply component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconMessageReply extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.71586 0.878401C9.99612 0.994487 10.1789 1.26796 10.1789 1.57131V5.96417H11.1431C15.7501 5.96417 18.5378 8.29939 20.3533 11.2497C21.7762 13.5619 22.6349 16.3146 23.3474 18.5988C23.5233 19.1627 23.6903 19.6981 23.8547 20.1913C23.9612 20.511 23.8414 20.8626 23.5618 21.0507C23.2822 21.2389 22.9114 21.2174 22.6554 20.9982C21.9828 20.4224 21.3849 19.8993 20.8417 19.4242C19.3203 18.0933 18.2294 17.139 17.1364 16.4578C15.7306 15.5816 14.3402 15.1785 12.0003 15.1785H10.1789V19.5713C10.1789 19.8812 9.98831 20.1591 9.6993 20.2709C9.41029 20.3826 9.08233 20.3051 8.8739 20.0758L0.302468 10.6472C0.0331672 10.351 0.0440067 9.8955 0.327093 9.61241L8.89852 1.04098C9.11302 0.826482 9.43561 0.762316 9.71586 0.878401ZM1.89343 10.1674L8.67885 17.6314V14.4285C8.67885 14.0142 9.01464 13.6785 9.42885 13.6785H12.0003C14.5632 13.6785 16.2414 14.1325 17.9298 15.1848C19.0568 15.8872 20.1981 16.8677 21.6204 18.1112C20.9748 16.0735 20.2284 13.9088 19.0758 12.0358C17.4628 9.41466 15.1076 7.46417 11.1431 7.46417H9.42885C9.01464 7.46417 8.67885 7.12838 8.67885 6.71417V3.38197L1.89343 10.1674Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconMessageReply.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconMessageReply.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconMessageReply.prototype, "size", void 0);
if (customElements.get('cat-icon-message-reply') === undefined) {
    customElements.define('cat-icon-message-reply', BlocksIconMessageReply);
}
